import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
const ColorFiltersPlaceholder = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Placeholder type="rect" loading={true} style={{
      width: "100px",
      height: "24px"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="items-center flex justify-between w-full mb-4">{t0}<div className="hidden md:block"><ul className="flex flex-wrap w-full overflow-auto py-2 px-1 m-0 list-none max-[767px]:hidden">{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(_temp)}</ul></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const MobileColorFiltersPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="flex w-full overflow-visible list-none md:hidden m-2 ml-0">{[0, 1, 2, 3, 4, 5, 6, 7, 8].map(_temp2)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const PDPUpholsteryFiltersPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="flex w-full overflow-visible pb-6 px-1 m-0 list-none md:mb-7">{[0, 1, 2, 3, 4, 5].map(_temp3)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const PDPUpholsterySortByPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Placeholder type="rect" loading={true} style={{
      minHeight: "38px"
    }} className="hidden md:block my-3" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const ActiveFabricAndSwatchButtonPlaceholder = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Placeholder type="round" loading={true} style={{
      width: "16px",
      height: "16px",
      margin: "0px"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-row w-[135px] h-[38px] justify-evenly items-center">{t0}<Placeholder type="rect" loading={true} style={{
        width: "100px",
        height: "16px",
        margin: "0px"
      }} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-row justify-between mb-2">{t1}<Placeholder type="rect" loading={true} style={{
        width: "185px",
        height: "38px",
        borderRadius: "9999px",
        margin: "0px"
      }} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const MaterialThumbnailGroupDesktopPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden flex-row flex-wrap w-full h-24 justify-between overflow-hidden lg:flex">{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map(_temp4)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const MaterialThumbnailGroupTabletPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden md:flex lg:hidden flex-row w-full h-14 overflow-visible">{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(_temp5)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const MaterialThumbnailGroupMobilePlaceholder = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex md:hidden flex-row w-full h-14 overflow-visible">{[0, 1, 2, 3, 4, 5].map(_temp6)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className="flex md:hidden flex-row w-full h-14 overflow-visible">{[0, 1, 2, 3, 4, 5].map(_temp7)}</div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const PDPSelectUpholsteryPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative [border-bottom:1px_solid_#e5e5e5] pb-8"><ColorFiltersPlaceholder /><MobileColorFiltersPlaceholder /><PDPUpholsteryFiltersPlaceholder /><PDPUpholsterySortByPlaceholder /><ActiveFabricAndSwatchButtonPlaceholder /><MaterialThumbnailGroupDesktopPlaceholder /><MaterialThumbnailGroupTabletPlaceholder /><MaterialThumbnailGroupMobilePlaceholder /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PDPSelectUpholsteryPlaceholder;
function _temp(index) {
  return <Placeholder key={index} type="round" loading={true} style={{
    width: "20px",
    height: "20px"
  }} className="mr-1" />;
}
function _temp2(index) {
  return <Placeholder key={index} type="round" loading={true} style={{
    minWidth: "40px",
    minHeight: "40px"
  }} className="mr-1" />;
}
function _temp3(index) {
  return <Placeholder key={index} type="rect" loading={true} style={{
    minWidth: "65px",
    minHeight: "35px"
  }} className="mb-1.5 mr-2.5 round" />;
}
function _temp4(index) {
  return <div className="w-12 h-12 p-0.5" key={index}><Placeholder type="rect" loading={true} style={{
      minWidth: "44px",
      minHeight: "44px",
      margin: "0px",
      borderRadius: "4px"
    }} /></div>;
}
function _temp5(index) {
  return <div className="w-14 h-14 p-0.5 m-2" key={index}><Placeholder type="rect" loading={true} style={{
      minWidth: "52px",
      minHeight: "52px",
      margin: "0px",
      borderRadius: "6px"
    }} /></div>;
}
function _temp6(index) {
  return <div className="w-12 h-12 p-0.5 m-2" key={index}><Placeholder type="rect" loading={true} style={{
      minWidth: "48px",
      minHeight: "48px",
      margin: "0px",
      borderRadius: "6px"
    }} /></div>;
}
function _temp7(index_0) {
  return <div className="w-12 h-12 p-0.5 m-2" key={index_0}><Placeholder type="rect" loading={true} style={{
      minWidth: "48px",
      minHeight: "48px",
      margin: "0px",
      borderRadius: "6px"
    }} /></div>;
}